import PropTypes from "prop-types"
import React from "react"

const JourneyStageCell = ({ step }) => {
  return (
    <div className="mt-1 text-xs text-gray-900">
      {step.summary && <span className="font-semibold">{step.summary} </span>}
      {step.label}
    </div>
  )
}

JourneyStageCell.propTypes = {
  step: PropTypes.shape({
    index: PropTypes.number,
    total: PropTypes.number,
    summary: PropTypes.string,
    label: PropTypes.string.isRequired,
  }).isRequired,
}

export default JourneyStageCell
